module.exports = new __parcel__URL__("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg").toString();